import Component, { mixins } from "vue-class-component";
import { ApplicationUserRoleMixin } from "@/mixins";

@Component
export class DlsUserRoleMixin extends mixins(ApplicationUserRoleMixin) {
    async mounted(): Promise<void> {
        await this.$store.dispatch("dls/loadValidators");
    }
}
